// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { mergeLocales } from './merge-locales';
export { normalizeLocale } from './normalize-locale';
export { normalizeStartOfWeek, DayIndex } from './normalize-start-of-week';



// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/src/internal/utils/locale/index.ts